import { render, staticRenderFns } from "./NewContactAndConversationForm.vue?vue&type=template&id=360a0c20&scoped=true&"
import script from "./NewContactAndConversationForm.vue?vue&type=script&lang=js&"
export * from "./NewContactAndConversationForm.vue?vue&type=script&lang=js&"
import style0 from "./NewContactAndConversationForm.vue?vue&type=style&index=0&id=360a0c20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a0c20",
  null
  
)

export default component.exports